export function getLinksForCustomer(customerID: string) {
  return fetch(
    `${process.env.REACT_APP_DEVICES_URL}/download-link/${customerID}`
  )
    .then((response) => response.json())
    .then((responseObject) => responseObject.data);
}
